import { render, staticRenderFns } from "./MerchantSettings.vue?vue&type=template&id=2bd16c6b&scoped=true"
import script from "./MerchantSettings.vue?vue&type=script&lang=js"
export * from "./MerchantSettings.vue?vue&type=script&lang=js"
import style0 from "./MerchantSettings.vue?vue&type=style&index=0&id=2bd16c6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd16c6b",
  null
  
)

export default component.exports